<template>
  <v-card class="fill-height"
          :loading="chartLoading">
    <v-card-title>
      <slot name="title"></slot>
    </v-card-title>
    <v-card-text class="px-8">
      <apexchart v-if="chartLoading === false"
                 type="area"
                 :height="chartHeight"
                 :options="chartOptions"
                 :series="chartSeries">
      </apexchart>
      <div v-else
           :style="`height: ${chartHeight}px`">
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import mailgunService from '../../../../../ml/services/mailgunService';
import moment from 'moment-timezone';

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    sender: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      emails: [],
      deliveries: [],
      opens: [],
      clicks: [],
      failures: [],
      chartHeight: 300,
      chartLoading: false,
      chartOptions: null,
      chartSeries: [],
    }
  },
  computed: {
    senderID() {
      return this.sender?.id;
    },
    campaignID() {
      return this.campaign.id;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.getDailyMetrics();
    },
    /**
     * MLD-6403
     * @see https://chatgpt.com/c/1d216290-d14e-4603-8891-44f065411e1e
     * @param point
     * @returns {(Date|*)[]}
     */
    formatDataPoint(point) {
      return [
        new Date(point.date).getTime(),
        point.value,
      ]
    },
    async getDailyMetrics() { // MLD-6072
      this.chartLoading = true;
      const form = {
        start: this.start,
        end: this.end,
      }
      // @see https://apexcharts.com/javascript-chart-demos/column-charts/basic/
      await Promise.all([
        mailgunService.getDailyEmailMetricsForCampaign(this.campaignID, 'created_at', form).then(data => this.emails = data),
        mailgunService.getDailyEmailMetricsForCampaign(this.campaignID, 'delivered_at', form).then(data => this.deliveries = data),
        mailgunService.getDailyEmailMetricsForCampaign(this.campaignID, 'opened_at', form).then(data => this.opens = data),
        mailgunService.getDailyEmailMetricsForCampaign(this.campaignID, 'clicked_at', form).then(data => this.clicks = data),
        mailgunService.getDailyEmailMetricsForCampaign(this.campaignID, 'failed_at', form).then(data => this.failures = data),
      ])
      this.chartSeries = [];
      this.chartSeries.push({
        name: 'Sent',
        data: this.emails.map(r => this.formatDataPoint(r)),
      })
      this.chartSeries.push({
        name: 'Delivered',
        data: this.deliveries.map(r => this.formatDataPoint(r)),
      })
      this.chartSeries.push({
        name: 'Opened',
        data: this.opens.map(r => this.formatDataPoint(r)),
      })
      this.chartSeries.push({
        name: 'Clicked',
        data: this.clicks.map(r => this.formatDataPoint(r)),
      })
      this.chartSeries.push({
        name: 'Failed',
        data: this.failures.map(r => this.formatDataPoint(r)),
      })
      this.chartOptions = {
        chart: {
          toolbar: { // @see https://apexcharts.com/docs/options/chart/toolbar/
            tools: {
              download: false,
              pan: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        xaxis: { // @see https://apexcharts.com/docs/options/xaxis/
          type: 'datetime',
        },
        yaxis: { // @see https://apexcharts.com/docs/options/yaxis/
          forceNiceScale: true,
        },
        // MLD-6403
        // @see https://chatgpt.com/c/1d216290-d14e-4603-8891-44f065411e1e
        tooltip: {
          x: {
            format: 'yyyy-MM-dd' // Format the tooltip date as 'YYYY-MM-DD'
          },
        }
      }
      this.chartLoading = false;
    }
  },
}
</script>
